<template>
  <v-app>
    <v-content>
      <v-container fluid fill-height>
        <v-layout align-center justify-center>
          <router-view @snackbar="startSnackbar"></router-view>
          <v-snackbar
           v-model="showSnackbar"
           :timeout="timeout"
           >
           {{ snackMessage }}
           <v-btn
             dark
             flat
             @click="showSnackbar = false"
           >
             Close
           </v-btn>
         </v-snackbar>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>
<script>
import AuthApi from '@/components/controllers/AuthApi';

export default {
  name: 'LoginMain',
  // data: () => ({
  data() {
    return {
      showSnackbar: false,
      snackMessage: '',
      timeout: 0,
      drawer: null,
      step1: true,
      emptyEmail: false,
      emptyPassword: false,
      forgotPassword: false,
      resetPassword: false,
      emailSent: false,
      user: {
        email: '',
        password: '',
      },
      newPassword: '',
      passwordCheck: '',
      emptyResetPassword: false,
      emptyResetPasswordConfirm: false,
      forgotParams: '',
      show1: false,
      show2: false,
      show3: false,
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /^.+@.+\..+$/.test(v) || 'E-mail must be valid',
      ],
      passwordRules: [
        v => !!v || 'Password is required',
        v => (v && v.length >= 8) || 'Password must be more than 8 characters',
      ],
      passwordCheckRules: [
        v => !!v || 'Password is required',
        v => v === this.newPassword || 'Passwords must match',
      ],
    };
  },
  props: {
    source: String,
  },
  created() {
  

  },
  mounted() {
    if( this.$route.query.token ){
      // lets logoput if any active sessions
      this.$store.dispatch('CLEAR_STORAGE');
      // Verify token if success re init or set login
      AuthApi.validateTokenWithResults(this.$route.query.token)
      .then((res) => {
        if(res.data.declaration === 'is_valid_token'){
          
          this.$store.dispatch('SET_STORAGE_TOKEN', { token: this.$route.query.token });
          this.$store.dispatch('SET_RESET_PASSWORD', { reset: false });
          this.$router.push('/home');

        } else {
          console.log('invalid')
        }
      }).catch(() => {
        console.log('invalid')
      });
    }
  },
  beforeDestroy() {
    this.forgotPassword = false;
  },
  methods: {
    startSnackbar(message) {
      this.snackMessage = message;
      this.showSnackbar = true;
    },
  },
};
</script>
